<div class="split-button"><slot name="first-side"></slot><slot name="last-side"></slot></div>